import React, { useState } from 'react';
import { Alert, Button, Card, CardBody, Spinner } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PhishingIcon from '../../../Layout/Components/PhishingIcon';
import PageTitle from '../../../Layout/Components/PageTitle';
import { getSMTPConfigList } from '../../../API/PhishingAPI';
import useChoices from '../useChoices';
import { SMTPPicker } from '../Simulations/SimulationPickers';
import ChoiceDeleteModal from '../Simulations/ChoiceDeleteModal';
import SMTPConfigModal from './SMTPConfigModal';
import '../Simulations/Simulations.css';
import './SMTPConfig.css';

export function SMTPConfig({ t }) {
  const profiles = useChoices(getSMTPConfigList);
  const [draft, setDraft] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);

  function saved(profile) { profiles.saved(profile); setDraft(null); }
  function deleted(_kind, profile) { profiles.removed(profile.id); setDeleteTarget(null); }
  function edit(profile) { setDraft({ profile }); }
  function copy(profile) { setDraft({ profile: { ...profile, name: t('smtp_config.copy_name', { name: profile.name }) }, copied: true }); }

  return <div className="simulation-wizard sending-profiles-page">
    <PageTitle heading={t('smtp_config.title')} subheading={t('smtp_config.workflow')} icon={<PhishingIcon name="smtp" />} />
    <Card className="simulation-wizard__shell"><CardBody>
      <div className="sending-profiles-page__heading">
        <div><h2>{t('smtp_config.your_profiles')}{profiles.items && <span>{profiles.items.length}</span>}</h2>
          <p>{t('smtp_config.manage_help')}</p></div>
        <Button color="primary" disabled={!profiles.items} onClick={() => setDraft({})}>+ {t('smtp_config.actions.create')}</Button>
      </div>
      {profiles.error && <Alert color="danger" role="alert">{t('smtp_config.load_error')}{' '}
        <Button color="link" onClick={profiles.load}>{t('template_gallery.retry')}</Button></Alert>}
      {!profiles.items ? !profiles.error && <div className="simulation-wizard__loading" role="status"><Spinner size="sm" /> {t('simulation_wizard.loading')}</div>
        : <SMTPPicker manage items={profiles.items} onSelect={edit} onEdit={edit} onCopy={copy} onCreate={() => setDraft({})}
          onDelete={item => setDeleteTarget({ kind: 'smtp', item })} t={t} />}
    </CardBody></Card>
    {draft && <SMTPConfigModal open showOpenButton={false} smtpConfig={draft.profile} copiedVersion={draft.copied}
      onClose={() => setDraft(null)} onSubmit={saved} contextHelp={t('simulation_wizard.smtp_edit_help')} />}
    {deleteTarget && <ChoiceDeleteModal target={deleteTarget} onClose={() => setDeleteTarget(null)} onDeleted={deleted} t={t} />}
  </div>;
}

export default withTranslation()(SMTPConfig);
